module.exports = __webpack_public_path__ + "img/novo.bc889ab2.svg";